/* eslint-disable no-shadow */
import Duck from 'extensible-duck';
import _get from 'lodash/get';
import {
  LOADING_INIT_DATA,
  LOAD_INIT_DATA_SUCCESS,
  LOAD_DATA_FULL_SUCCESS,
  LOAD_DATA_DYNAMIC_SUCCESS,
} from '../actions/api-actions';
import {
  getDynamicAndStaticData,
  isExpiredTrip,
  isInvalidTrip,
  isSingleTrip,
} from '../common/utils/trip';
import { convertLatLongToArray } from '../common/utils/map';

const initialState = {
  allPoints: null,
  locations: {
    origin: null,
    destinations: [],
  },
  steps: [],
  driver: {
    bearing: 0,
    coordinates: null,
    type: 'BIKE',
  },
  focusFlag: false,
};

export default new Duck({
  namespace: 'ge-delivery',
  store: 'map',
  initialState,
  types: ['FOCUS_MAP'],
  creators: duck => ({
    focusMap: () => ({
      type: duck.types.FOCUS_MAP,
    }),
  }),
  selectors: duck => ({
    map: state => state[duck.store],
  }),
  reducer: (state, action, duck) => {
    switch (action.type) {
      case duck.types.FOCUS_MAP: {
        const { allPoints, focusFlag } = state;

        if (allPoints && Array.isArray(allPoints))
          return {
            ...state,
            allPoints: allPoints.map(points => {
              const [long, lat] = points;
              // 0.000001 bring no different visually, but mapbox does react
              const direction = focusFlag ? 0.000001 : -0.000001;
              return [long + direction, lat + direction];
            }),
            focusFlag: !focusFlag,
          };

        return state;
      }

      case LOADING_INIT_DATA:
        return initialState;

      case LOAD_DATA_DYNAMIC_SUCCESS: {
        const { data } = action;

        if (isInvalidTrip(data) || isExpiredTrip(data)) return state;
        const { webTrackingDetails } = data;

        const { dynamicData } = getDynamicAndStaticData(webTrackingDetails[0]);
        const { currentLocation, bearing } = dynamicData;

        const steps = _get(dynamicData, 'steps') || [];

        const currentLocationLatLong = convertLatLongToArray(currentLocation);

        const stepsLatLong = steps.map(step =>
          convertLatLongToArray({ lat: step.latitude, long: step.longitude }),
        );

        const driver = {
          bearing,
          coordinates: currentLocationLatLong,
        };

        return {
          ...state,
          steps: stepsLatLong,
          driver,
        };
      }

      case LOAD_INIT_DATA_SUCCESS:
      case LOAD_DATA_FULL_SUCCESS: {
        const { data } = action;

        if (isInvalidTrip(data) || isExpiredTrip(data)) return state;
        const { webTrackingDetails } = data;

        const { staticData, dynamicData } = getDynamicAndStaticData(
          webTrackingDetails[0],
        );
        const { origin, destination } = staticData.delivery;
        const { currentLocation, bearing } = dynamicData;

        const steps = _get(dynamicData, 'steps') || [];

        const originLatLong = convertLatLongToArray(origin.coordinates);
        const destinationLatLong = convertLatLongToArray(
          destination.coordinates,
        );

        const currentLocationLatLong = convertLatLongToArray(currentLocation);

        const allPoints = [
          originLatLong,
          destinationLatLong,
          currentLocationLatLong,
        ].filter(Boolean);

        const stepsLatLong = steps.map(step =>
          convertLatLongToArray({ lat: step.latitude, long: step.longitude }),
        );

        const driver = {
          bearing,
          coordinates: currentLocationLatLong,
          type: _get(staticData, 'serviceType', 'BIKE'),
        };

        const locations = {
          origin: {
            name: origin.name,
            address: origin.address,
            coordinates: originLatLong,
            instruction: origin.instruction,
          },
          destinations: [
            {
              name: destination.name,
              address: destination.address,
              coordinates: destinationLatLong,
              instruction: destination.instruction,
            },
          ],
        };

        if (isSingleTrip(data)) {
          return {
            ...state,
            allPoints,
            locations,
            steps: stepsLatLong,
            driver,
          };
        }

        // MSD
        webTrackingDetails.slice(1).forEach(webTrackingDetail => {
          const { staticData } = getDynamicAndStaticData(webTrackingDetail);
          const { destination } = staticData.delivery;
          const destinationLatLong = convertLatLongToArray(
            destination.coordinates,
          );
          allPoints.push(destinationLatLong);
          locations.destinations.push({
            name: destination.name,
            address: destination.address,
            instruction: destination.instruction,
            coordinates: destinationLatLong,
          });
        });

        return {
          ...state,
          allPoints,
          locations,
          steps: stepsLatLong,
          driver,
        };
      }
      default:
        return state;
    }
  },
});
